import React from 'react';
import "./Offer.css";
import { Link } from "react-router-dom";

import img from "../../../images/home/sideways-woman-looking-sad-as-she-works-from-home.jpg";
import img3 from "../../../images/home/hands-holding-each-other-support.jpg";
import img2 from "../../../images/home/close-up-hands-writing-japanese-message.jpg";

const Offer = () => {
  return (
<section className="container" style={{ marginTop: 50}}>
  <div className="mb-5 section-title text-center">
    <h2>Usługi</h2>
    <p className="m-0">Twoje zdrowie psychiczne w zasięgu ręki.</p>
  </div>

  <div className="custom-columns-wrapper d-flex flex-wrap justify-content-center gap-4">
    <div className="service-img-column">
      <div className="service-img">
        <img src={img} alt="" className="img-fluid" />
        <img src={img2} alt="" className="img-fluid mt-4" />
      </div>
    </div>

    <div className="service-img-column vertical-center">
      <div className="service-img mt-4 mt-lg-0">
        <img src={img3} alt="" className="img-fluid" />
      </div>
    </div>

    <div className="service-content-column vertical-center">
      <div className="service-content ps-4 mt-4 mt-lg-0">
        <h2>
          Profesjonalne wsparcie <br />
          zdrowia psychicznego
        </h2>
        <p className="mt-4 mb-4 text-secondary form-text">
          W Synavie oferujemy profesjonalne diagnozy ADHD, autyzmu, zaburzeń osobowości oraz konsultacje psychologiczne.
          Dzięki w pełni zdalnemu procesowi zapewniamy wygodę i oszczędność czasu, bez konieczności wychodzenia z domu.
        </p>
        <div className="text-center">
          <Link to={"/oferta"} className="btn-offer">
            Oferta
          </Link>
        </div>
      </div>
    </div>
  </div>
</section>
  );
};

export default Offer;
